import { MAIN_SITE_URL } from '@/utils/constants';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%20on%20a%20warm%20cream%20wooden%20desk%2C%20surrounded%20by%20carefully%20arranged%20lifestyle%20products%20including%20sneakers%2C%20accessories%20and%20clothing%20items%2C%20soft%20natural%20window%20light%20from%20the%20left%2C%20airy%20atmosphere%20with%20warm%20neutral%20tones%2C%20clean%20aesthetic%20editorial%20photography%2C%20organic%20textures%2C%20shallow%20depth%20of%20field%20with%20smooth%20background%20blur%2C%20peaceful%20productivity%20vibe&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="Sugargoo Spreadsheet resource hub with organized product data"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-2xl">
          <p className="text-sm font-medium text-background-50/80 mb-4 tracking-wide uppercase">
            Updated Weekly &bull; Free Resources &bull; Shopping Guides
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
            Sugargoo Spreadsheet &mdash; Discover Updated Finds, Products &amp; Shopping Guides
          </h1>
          <p className="text-base md:text-lg text-background-50/85 leading-relaxed mb-8 max-w-xl">
            Find the latest <strong>Sugargoo Spreadsheet</strong> resources, product collections, shipping guides, discount information and expert reviews in one trusted platform.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#categories"
              className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Explore Sugargoo Spreadsheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-down-line text-sm"></i>
              </span>
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 text-sm md:text-base font-semibold hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Visit Main Website
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-external-link-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}